
// Productos.js
import React from 'react';

const Productos = () => {
  return <div>Productos Page</div>;
};

export default Productos;